module Web.HTML.Event.PopStateEvent.EventTypes where

import Web.Event.Event (EventType(..))

popstate :: EventType
popstate = EventType "popstate"
